// Utilitaire pour gérer les URLs de l'API et des ressources
// ========================================================

/**
 * Retourne l'URL de base pour l'API (vide = même origine, proxy NPM /api en prod).
 */
export const getApiBaseUrl = () => '';

/**
 * Préfixe API REST (/api) — même origine en prod et en dev.
 */
export const getApiRoot = () => '/api';

export const getResourceUrl = (path) => {
  if (!path) return '';

  if (path.startsWith('http')) {
    return path;
  }

  if (process.env.NODE_ENV === 'production') {
    return `https://taxiabel.fr${path.startsWith('/') ? path : `/${path}`}`;
  }

  return path.startsWith('/') ? path : `/${path}`;
};

/**
 * URL stable (cache navigateur / LCP) sans paramètre anti-cache.
 */
export const getStableImageUrl = (imagePath) => {
  if (!imagePath) return '';
  return getResourceUrl(imagePath);
};

/**
 * Retourne l'URL pour une image avec un timestamp pour éviter le cache (admin / previews).
 */
export const getImageUrl = (imagePath, options = {}) => {
  const { bustCache = false } = options;
  const baseUrl = getStableImageUrl(imagePath);
  if (!baseUrl) return '';
  if (!bustCache) return baseUrl;
  return `${baseUrl}?t=${Date.now()}`;
};

/**
 * Retourne l'URL pour une image avec fallback en cas d'erreur
 */
export const getImageUrlWithFallback = (imagePath, fallbackPath = '/uploads/default-image.jpg') => {
  if (!imagePath) return getImageUrl(fallbackPath);
  return getImageUrl(imagePath);
};

/**
 * Retourne l'URL pour l'API
 */
export const getApiUrl = (endpoint) => {
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${getApiRoot()}${normalizedEndpoint}`;
};
